export const SCROLL_AMOUNT = 200
export const SCROLL_LEFT = {
  left: -SCROLL_AMOUNT,
  right: SCROLL_AMOUNT
}

export type TScrollDirection = 'left' | 'right'

export const scrollElementToPosition = (
  direction: TScrollDirection,
  element: HTMLDivElement | null
) => {
  if (element) {
    element.scrollLeft += SCROLL_LEFT[direction]
  }
}
